import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import _ from 'lodash';
import * as types from '../types';
import * as actions from '../actions';
import * as selectors from '../selectors';
import EntityForm from './EntityForm';
import Breadcrumbs from './Breadcrumbs';

const EntityExplorer: React.FC<{
    name: string;
    id?: types.ID;
    onComplete?: types.onCompleteHandler;
}> = ({
    name,
    id,
    onComplete,
}) => {
        const dispatch = useDispatch();
        const stack: types.StackItem[] = useSelector(selectors.SelectStack());
        // const resource: Resource = conf.getResource(name);

        const { id: urlParamId } = useParams<{ id: string }>();

        const locator: types.Locator = useMemo(
            () => ({
                name,
                id: id ?? urlParamId!,
            }),
            [name, urlParamId, id]
        );

        useEffect(() => {
            dispatch(actions.reset(locator));
        }, [locator]);

        return <Box>

            <Breadcrumbs />

            {
                (stack.length > 0) &&
                <EntityForm
                    locator={_.last(stack)!.locator}
                    onComplete={stack.length === 1 ? onComplete : undefined}
                />
            }
        </Box>
    };

export default EntityExplorer;
